import Vue from "vue";
// import scrollbar from 'element-ui/lib/scrollbar'
//
// import {
//   Input,
//   Button,
//   Row,
//   Col,
//   Pagination,
//   Checkbox,
//   Loading,
//   Alert,
//   Message,
//   Radio,
//   RadioGroup,
//   RadioButton,
//   Breadcrumb,
//   BreadcrumbItem,
//   Dialog,
//   Menu,
//   Submenu,
//   MenuItem,
//   MenuItemGroup,
//   Dropdown,
//   DropdownMenu,
//   DropdownItem,
//   Form,
//   FormItem,
//   Select,
//   Option,
//   Tooltip,
//   Table,
//   TableColumn,
//   Icon,
//   MessageBox,
//   Popover,
//   Backtop
// } from 'element-ui'
//
// Vue.use(Input)
// Vue.use(Table)
// Vue.use(TableColumn)
// Vue.use(Button)
// Vue.use(Row)
// Vue.use(Col)
// Vue.use(Pagination)
// Vue.use(Checkbox)
// Vue.use(Alert)
// Vue.use(Radio)
// Vue.use(RadioGroup)
// Vue.use(RadioButton)
// Vue.use(Breadcrumb)
// Vue.use(BreadcrumbItem)
// Vue.use(Dialog)
// Vue.use(Menu)
// Vue.use(Submenu)
// Vue.use(MenuItem)
// Vue.use(MenuItemGroup)
// Vue.use(Dropdown)
// Vue.use(DropdownMenu)
// Vue.use(DropdownItem)
// Vue.use(Form)
// Vue.use(FormItem)
// Vue.use(Select)
// Vue.use(Option)
// Vue.use(Tooltip)
// Vue.use(Icon)
// Vue.use(Popover)
// Vue.use(Backtop)
// Vue.use(scrollbar)
// Vue.use(Loading.directive)
// Vue.prototype.$message = Message
// Vue.prototype.$confirm = MessageBox.confirm

import ElementUI from 'element-ui'
Vue.use(ElementUI)
